import { render } from "./ProductPreview.vue?vue&type=template&id=b6890fc6&scoped=true"
import script from "./ProductPreview.vue?vue&type=script&lang=js"
export * from "./ProductPreview.vue?vue&type=script&lang=js"

import "./ProductPreview.vue?vue&type=style&index=0&id=b6890fc6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6890fc6"],['__file',"resources/js/modules/product-mapping/components/ProductPreview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6890fc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6890fc6', __exports__)) {
    api.reload('b6890fc6', __exports__)
  }
  
  module.hot.accept("./ProductPreview.vue?vue&type=template&id=b6890fc6&scoped=true", () => {
    api.rerender('b6890fc6', render)
  })

}


export default __exports__